<template>
  <div class="bg">
    <div class="content">
      <div class="container">
        <span id="first"><router-link to="/firm-intro">关于我们</router-link></span>
        <!-- <span class="middle">安全保障</span> -->
        <span class="middle"><router-link to="/contact">联系我们</router-link></span>
        <span class="last"><router-link to="/join-us/market">诚聘英才</router-link></span>
        <!-- <span id="last">法律声明</span> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'homeAboutUs'
  }
</script>

<style scoped>
  div.bg {
    display: block;
  }
  div.content {
    background-color: rgb(242, 242, 242);
    width: 980px;
    margin: auto;
    padding: 0;
    display: block;
    text-align: center;
  }
  div.container {
    margin-top: 20px;
    padding: 0;
    width: auto;
  }

  a {
    width: inherit;
    height: inherit;
    color: rgb(73,73,73);
    text-decoration: none;
    margin: 0;
    padding: 0;
  }

  span {
    margin: 0;
    padding-right: 5px;
  }
  .middle {
    border-right: solid;
    color: rgb(73,73,73);
    border-width: thin;
  }
  #last {

  }
  #first {
    border-right: solid;
    color: rgb(73,73,73);
    border-width: thin;
  }
</style>



// WEBPACK FOOTER //
// HomeAboutUs.vue?2b89def8